<template>
<div class="vld-parent" style="width: 100%;height: 60%;">
  <loading :active.sync="isLoading" :is-full-page="true"></loading>
<ag-grid-vue style="width: 100%;height: 100%;"
                 class="ag-theme-balham"                 
                 :columnDefs="columnDefs" 
                 :gridOptions="gridOptions"
                 :rowMultiSelectWithClick="true"
                  :defaultColDef="defaultColDef"
                 :rowSelection="rowSelection"
                 :rowHeight=50
                 @selection-changed="onSelectionChanged"
                 :rowData="trasactions">
                </ag-grid-vue>

<v-card class='bottom-panels'>
    <v-tabs
      v-model="tab" icons-and-text>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Invoices List
        <v-icon>mdi-details</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        Financial Transactions
        <v-icon>mdi-cash-usd</v-icon>
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item        
        :key="1"
        :value="'tab-' + 1"
      >
        <v-card flat>
          <invoices class='bottom-panel' :selected-customer-id=selectedCustomerId />
        </v-card>
      </v-tab-item>
      <v-tab-item        
        :key="2"
        :value="'tab-' + 2"
      >
        <v-card flat>
          <finance class='bottom-panel' :selected-customer-id=selectedCustomerId />
          
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>


</div>



</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import { ledgerService } from './../../services/'        
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Finance from './Finance.vue';
    import Invoices from './Invoices.vue';
  export default {
    name: 'AssetsPage',
    data: () => ({      
       isLoading: true,
        fullPage: true,
        selectedCustomerId:null,
        gridOptions: null,
        tab:null,
        gridApi: null,  
        snackbar: false,
        rowSelection: null,
        trasactions:[],
        response:null,
         columnDefs:[          
          { headerName: 'Customer No', field:'id'},
          { headerName: 'Customer Name', field:'name'},
          { headerName: 'Acccount Type', field:'accountType'},
          { headerName: 'City' , field: 'city.name'} ,
          { headerName: 'Postcode' , field: 'postCode'} ,
          { headerName: 'Contact No' , field: 'contactNumber'} ,
          { headerName: 'Credit Limit', field:'creditLimit'},
          { headerName: 'Current Balance', field:'balance',valueFormatter: params => params.data.balance.toFixed(2)},
          { headerName: 'Due Date', field:''},
          { headerName: 'Remarks', field:'invoices.0.remarks'},
        ], 
    }),
    components: {
            AgGridVue,            
            Loading,
        Finance,
        Invoices
    },    
    methods: { 
      loadTransactions() {
        let self=this        
        self.isLoading=true
        ledgerService.getLedgerTransactions().then(trasactions=> {              
              self.trasactions=trasactions
              self.isLoading=false
        })
    },           

    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();      
      this.selectedCustomerId=selectedRows[0].customerId;
    },

    },
    beforeMount() {
      this.gridOptions = {};
      this.rowSelection = 'single';
      this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,            
    };
    },
    
    mounted () {     
        this.gridApi = this.gridOptions.api;   
        this.loadTransactions()        
    }
  }
  
</script>
<style >
.ag-theme-balham .ag-cell .ag-icon {
  display: flex;
  vertical-align:auto  
}

.bottom-panels {
  margin-top:20px
}

.bottom-panel {
  height: 40%;
  bottom:0
}


</style>
